// tslint:disable: max-line-length
import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwQueryFilter, DwOperator, DwFilterType } from '@devwareapps/devware-cap';
import { DwFormControlLookupComponent } from '@devwareapps/devware-cap';
import { GoogleMapsModule } from '@angular/google-maps';
import { AppMetaDataService, LicensesEntity, AppMetaDataLookups, PayJobChangeEntity, EthosUserEntity } from 'src/app/meta-data/app-meta-data.service';
import { flatMap, combineLatest, map, last, debounceTime } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { validateClaimsRequest } from 'msal/lib-commonjs/AuthenticationParameters';
import { AbstractControl, FormControl } from '@angular/forms';
import { ConfigService } from 'src/environments/environment';
import { NumberSequence } from 'ag-grid-community';
import { PayJobChangeService } from '../../services/pay-job-change.service';
import {  EthosUserInfoBaseComponent } from '../base/ethos-user-info-base.component';


@DwComponent({
  name: 'OldManager',
  parentItemName: 'PayJobChange',
  componentType: DwComponentType.formSection,
})

@Component({
  selector: 'app-old-manager-control',
  templateUrl: 'old-manager.component.html'
})
export class OldManagerComponent extends EthosUserInfoBaseComponent {
  getLookupId(): number {
    return AppMetaDataLookups.ETHOSUSERWachterEmployeesActiveEmployees;
  }

  setTrustUserValues(user: EthosUserEntity) {
    this.setLookupValue(user.SupervisorUserId);
  }
}
